import "./styles/challenge-container.css";
import { Outlet } from "react-router-dom";

const ChallengeContainer = () => {
  return (
    <div className="challenges">
      <Outlet />
    </div>
  );
};

export default ChallengeContainer;
